import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';

import {
  IServicePickerWidgetState,
  ServicePickerWidgetReducers,
  TServicePickerWidgetActions,
} from '../../../ServicePickerWidget';

import { MicrofrontendReducers } from '../../../Microfrontend';

import { IAppInitialState, IAppState, IStoreContext, TActions, TReduxStore } from '../../types';
import { rootSaga } from '../../sagas';
import { IServicePickerWidgetStateV2 } from '../../../ServicePickerWidget/types/reducers';
import { ServicePickerWidgetReducersV2 } from '../../../ServicePickerWidget/reducers';

export const createReduxStore = (initialState: IAppInitialState, context: IStoreContext) => {
  const reducers = combineReducers<IAppState, TActions>({
    servicePickerWidget: combineReducers<IServicePickerWidgetState, TServicePickerWidgetActions>(
      ServicePickerWidgetReducers,
    ),
    microfrontend: MicrofrontendReducers,
    servicePickerWidgetV2: combineReducers<IServicePickerWidgetStateV2, TServicePickerWidgetActions>(
      ServicePickerWidgetReducersV2,
    ),
  });

  const thunkMiddleware = thunk.withExtraArgument(context);
  const sagaMiddleware = createSagaMiddleware({ context });

  const reduxDevToolsName = `Service picker widget · ${context.config.get('mcsRunEnv')} · ${context.config.get(
    'version.commit',
  )}`;

  const composeEnhancers = composeWithDevTools({ name: reduxDevToolsName, trace: true, traceLimit: 20 });

  const storeEnhancers = composeEnhancers(applyMiddleware(thunkMiddleware, sagaMiddleware));

  const _createStore = (): TReduxStore => createStore(reducers, initialState as Partial<IAppState>, storeEnhancers);

  const store = _createStore();

  sagaMiddleware.run(rootSaga);

  return store;
};
